export default "__VITE_ASSET__B$r1OlrH__"